export { default } from './svg/dot-drag-grip.svg';
